import axios from 'axios'
import { CHAT_ENDPOINTS } from '../config/chatEndpoints'

export const createRoutineAdvice = async (payload) => {
  const response = await axios.post(
    CHAT_ENDPOINTS.createRoutineAdvice,
    payload,
    {
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    },
  )

  return response.data
}